// extracted by mini-css-extract-plugin
export default {"content":"reasons-modal_content__Rhtvf","actions":"reasons-modal_actions__GS6ce","confirm":"reasons-modal_confirm__7nrHC","discard":"reasons-modal_discard__0gI2R"};